import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StartupStepsMiddleware } from './startup-steps.middleware';
import { StartupState } from './startup.state';
import { addStepMethod } from './startup-operators';
import {
  AppNativeEventsStep,
  AppsFlyerDeepLinkingStep,
  AppTrackingTransparencyStep,
  AppUrlOpenStep,
  ConnectAuthStep,
  HideSplashScreenStep,
  InitNavigationStep,
  LoadFeatureFlagsStep,
  MetaInitStep,
  NotificationsStep,
  ObserveNotificationStep,
  RemoteConfigInitStep,
  SetDefaultFiltersStep,
  SetupAlertsStep,
  ShowSplashScreenStep,
  UpdateUserLocationStep,
  VersionConfigSyncStep
} from './steps';
import { Log } from '@core';

@Injectable({
  providedIn: 'root'
})
export class StartupStepService extends StartupStepsMiddleware<StartupState> {
  private _initState?: StartupState = {};

  get state(): StartupState | undefined {
    return this._initState;
  }

  init(initState?: StartupState): Observable<StartupState> {
    this._initState = {
      ...initState
    };

    this.logger.log(Log.Important, { message: 'Startup steps flow start.' });

    this.configure(addStepMethod(this.injector, (state: StartupState) => new ShowSplashScreenStep(state)()));
    this.configure(addStepMethod(this.injector, (state: StartupState) => new RemoteConfigInitStep(state)()));
    this.configure(addStepMethod(this.injector, (state: StartupState) => new VersionConfigSyncStep(state)()));
    this.configure(addStepMethod(this.injector, (state: StartupState) => new HideSplashScreenStep(state)()));
    this.configure(addStepMethod(this.injector, (state: StartupState) => new AppUrlOpenStep(state)()));
    this.configure(addStepMethod(this.injector, (state: StartupState) => new ConnectAuthStep(state)()));

    //WITH AUTH
    this.configure(addStepMethod(this.injector, (state: StartupState) => new LoadFeatureFlagsStep(state)()));
    this.configure(addStepMethod(this.injector, (state: StartupState) => new SetDefaultFiltersStep(state)()));
    this.configure(addStepMethod(this.injector, (state: StartupState) => new NotificationsStep(state)()));
    this.configure(addStepMethod(this.injector, (state: StartupState) => new ObserveNotificationStep(state)()));
    this.configure(addStepMethod(this.injector, (state: StartupState) => new UpdateUserLocationStep(state)()));
    this.configure(addStepMethod(this.injector, (state: StartupState) => new SetupAlertsStep(state)()));

    //WITHOUT AUTH
    this.configure(addStepMethod(this.injector, (state: StartupState) => new AppNativeEventsStep(state)()));
    this.configure(addStepMethod(this.injector, (state: StartupState) => new InitNavigationStep(state)()));
    this.configure(addStepMethod(this.injector, (state: StartupState) => new AppTrackingTransparencyStep(state)()));
    this.configure(addStepMethod(this.injector, (state: StartupState) => new MetaInitStep(state)()));
    this.configure(addStepMethod(this.injector, (state: StartupState) => new AppsFlyerDeepLinkingStep(state)()));

    return this.run({ ...initState });
  }
}
